// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface AnnouncementTypeDTO extends EntitySelectorDTO { 
	id: number;
	name: string | null;
	displayOrder: number;
}

const AnnouncementTypeDTO = {
    className: 'AnnouncementTypeDTO',
    create: (initValues?: Partial<AnnouncementTypeDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			name: "",
			displayOrder: 0,
        },
        initValues);
    },
	id: 'id',
	name: 'name',
	displayOrder: 'displayOrder',
};

export default AnnouncementTypeDTO;